import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { ColDef } from '@/types/common.types';

interface ColumnPickerProps {
  cols: ColDef[];
  hidden: Set<string>;
  onToggle: (key: string, visible: boolean) => void;
  onReset: () => void;
}

export function ColumnPicker({ cols, hidden, onToggle, onReset }: ColumnPickerProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function h(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  return (
    <div className="col-picker-wrap" ref={ref}>
      <button className="col-picker-btn" onClick={() => setOpen(o => !o)}>
        <i className="fas fa-columns" /> <span>{t('admin.columns')}</span>
      </button>
      {open && (
        <div className="col-picker-dropdown open">
          <div className="col-picker-header">
            <span>{t('admin.colPickerTitle')}</span>
            <button className="col-picker-reset" onClick={onReset}>{t('admin.colPickerReset')}</button>
          </div>
          {cols.map(c => (
            <label key={c.key} className={`col-picker-item${c.locked ? ' locked' : ''}`}>
              <input
                type="checkbox"
                checked={!hidden.has(c.key)}
                disabled={c.locked}
                onChange={e => onToggle(c.key, e.target.checked)}
              />
              <span>{t(c.labelKey)}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
